/**
 * for searchmodel javascript
 */

$(function(){
    var $updateForm = $("#updateForm"),
        $inputRf = $("input[name=rf]"),
    	$inputKeyword = $("input[name=k]"), 
    	$inputOffset= $("input[name=o]"), 
    	$addKeywordInput = $(".js_addKeywordInput"), 
    	$addKeywordBtn = $(".js_addKeywordBtn"), 
    	$processing = $("#processing"); 
    
    perfectMatchSearch= $(".js_perfectMatchSearch"); 
    $removeKeywordSearch=$(".js_removeKeyword");
    $addKeywordData=$(".js_separateKeywords");

    var convertCluezCategoryId = function convertCluezCategoryId(numberId) {
    	var id = parseInt(numberId);
    	var part1 = Math.floor(id / 100000);
    	var part2 = id - (part1 * 100000);
    	var finalId = part1+"_"+part2
    	return finalId;
    }
    
    /**
     * Sample input 
     * |100004 => |1_4
     * |500004 => |5_4
     */
    var parseCluezCategoryId = function parseCluezCategoryId(input) {
    	var originalId = input.substring(1);
    	var parts = originalId.split("|");
    	var parsedParts = [];
    	for(var i = 0; i < parts.length; i++) {
    		let part = parts[i];
    		let id = convertCluezCategoryId(part);
    		parsedParts.push(id);
    	};
    	var parsedId = "|"+parsedParts.join("|");
    	return parsedId;
    }
    
    $removeKeywordSearch.on("click", function(){
    	var keywordIndex = $(this).data("kindex");
    	var keywords = "";
    	if($addKeywordData.length){
    		$addKeywordData.each(function(){
    			var thisParentElm = $(this);
    			if(keywordIndex !== thisParentElm.data("kindex")) {
    				if( keywords.length > 0 ){
    					keywords += " ";
    				}
    				keywords += thisParentElm.data("keyword");
    			}
    		});
    	}
        $inputKeyword.val(keywords);
        $inputOffset.val(1);
        $inputRf.val('1104');
        $updateForm.submit();

    });
    
    $addKeywordInput.on("keypress", function(e){
        if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
            e.stopPropagation();
            var addKeyword = $(this).val().trim();
            if( addKeyword.length == 0){
            	return;
            }
            var keywords = $inputKeyword.val();
            if( keywords.length > 0 ){
                keywords += " ";
            }
            keywords += addKeyword;
            $inputKeyword.val(keywords);
            $inputOffset.val(1);
            $inputRf.val('1104');
            $updateForm.submit();
    	}
    });
    
    $addKeywordBtn.on("click", function(e){
        e.stopPropagation();
        var addKeyword = $addKeywordInput.val().trim();
        if( addKeyword.length == 0){
        	return;
        }
        var keywords = $inputKeyword.val();
        if( keywords.length > 0 ){
            keywords += " ";
        }
        keywords += addKeyword;
        $inputKeyword.val(keywords);
        $inputOffset.val(1);
        $inputRf.val('1104');
        $updateForm.submit();
    });
    
    $(".js_category").on("click", function(e){
        e.stopPropagation();
        var $category = $(this).children(".js_facetCategory");
        var $input = $("input[name=fc]");
        if( $input.length === 0){
            $("<input>").attr({
                type: "hidden",
                name: "fc",
                value: $category.data("category")
              }).appendTo($updateForm);
        }else{
            $input.val($category.data("category"));
        }
        $inputOffset.val(1);
        $updateForm.submit();
    });
    $(".js_facetCategory").on("click", function(e){
      e.stopPropagation();
      var $category = $(this);
      var $input = $("input[name=fc]");
      if( $input.length === 0){
          $("<input>").attr({
              type: "hidden",
              name: "fc",
              value: $category.data("category")
            }).appendTo($updateForm);
      }else{
    	  $input.val($category.data("category"));
      }
      $inputOffset.val(1);
      $updateForm.submit();
    });
    
    var $inputManufacturers = $("input[name=facetManufacturer]"), 
    	$inputCatalogDocumentTypes = $("input[name=facetCatalogDocumentType]"), 
    	filterFacetQueue;
    
    $inputManufacturers.on("click", function(e){
      e.stopPropagation();
      // イベント発生の都度、キューをキャンセル
      clearTimeout( filterFacetQueue );
      // イベント設定
      filterFacetQueue = setTimeout(function() {
        actionFilter("fb", $inputManufacturers, $updateForm);
      },300 );
    });
    $inputCatalogDocumentTypes.on("click", function(e){
        e.stopPropagation();
        // イベント発生の都度、キューをキャンセル
        clearTimeout( filterFacetQueue );
        // イベント設定
        filterFacetQueue = setTimeout(function() {
          actionFilter("fcdt", $inputCatalogDocumentTypes, $updateForm);
        },300 );
      });
    var $selectManufacturer = $(".js_select_manufacturer"), 
    	$selectCatalogDocumentType = $(".js_select_catalogDocumentType");
    
    if( $selectManufacturer.length ){
        $selectManufacturer.on("click", function(e){
            e.stopPropagation();
            actionSelect("fb", $inputManufacturers, $(this).data("value"), $updateForm);
        });
    }
    if( $selectCatalogDocumentType.length ){
    	$selectCatalogDocumentType.on("click", function(e){
            e.stopPropagation();
            actionSelect("fcdt", $inputCatalogDocumentTypes, $(this).data("value"), $updateForm);
        });
    }
    
    perfectMatchSearch.on("click", function(e){
    	$(this).parents("form").submit();
    });
    
    $(".js_releaseCategory").on("click", function(e){
        e.stopPropagation();
        var $input = $("#updateForm [name=fc]");
        $input.remove();
        $inputOffset.val(1);
        $processing.addClass("open");
        $updateForm.submit();
        
    });
    
    $(".js_releaseManufacturer").on("click", function(e){
        e.stopPropagation();
        releaseFilter("fb", $inputManufacturers);
    });
    
    $(".js_releaseCatalogDocumentType").on("click", function(e){
        e.stopPropagation();
        releaseFilter("fcdt", $inputCatalogDocumentTypes);
    });
    
    $("#searchResult_num").on("change", function(e){
        var newVal = $(this).val();
        $input = $("#updateForm [name=l]");
        $input.val(newVal);
        $input = $("#updateForm [name=o]");
        $input.val(1);        
        $updateForm.submit();
    });
    
    moreList(".js_moreCategory", ".js_categoryList");
    moreList(".js_moreManufacturer", ".js_manufacturerList");
    moreList(".js_moreCatalogDocumentType", ".js_catalogDocumentTypeList");
    
    allList(".js_allManufacturer",".js_all_manufacturer_list");
    allList(".js_allCatalogDocumentType",".js_all_catalogDocumentType_list");
    
    //サイドバーアコーディオン
    $(".acdn-toggle").on("click", function(e){
        var $trigger = $(this);
        var $categoryTitleTarget = $trigger.children(".icon");
        if( $categoryTitleTarget.hasClass("icon-plus")){
            $categoryTitleTarget.removeClass("icon-plus").addClass("icon-minus");
        }else{
            $categoryTitleTarget.removeClass("icon-minus").addClass("icon-plus");
        }
        var $categoryList = $($trigger.data("target"));
        if( $categoryList.length){
            $categoryList.slideToggle();
        }
    });
    
    var $body = $("body"), $content = $("#wrapper"), $drawer = $("#drawer"), $button = $("#spDrawer"), $overlay = $("#overlay"), $searchResult = $(".js_search_result");
    //ボタンによる開閉
    $button.on("click", function (e) {
        e.stopPropagation();
        drawerToggle();
    });
    $overlay.on("click", function (e) {
        if( $body.hasClass("open") ){
            e.stopPropagation();
            drawerToggle();
        }
    });
    
    
    function drawerToggle(){
    	if( $body.hasClass("open") ){
            $drawer.removeClass("open");
            $content.removeClass("open");
            $button.removeClass("open");
            $overlay.removeClass("open");
            $body.removeClass("open");
        }else{
            var $manufacturerList = $(".js_all_manufacturer_list"), $seriesList = $(".js_all_series_list"), $supplierList = $(".js_all_supplier_list");
            if( $manufacturerList.length ){
                if( !$manufacturerList.hasClass("hide") ){
                	$manufacturerList.addClass("hide")
                }
            }
            if( $seriesList.length ){
                if( !$seriesList.hasClass("hide") ){
                    $seriesList.addClass("hide")
                }
            }
            if( $supplierList.length ){
                if( !$seriesList.hasClass("hide") ){
                    $seriesList.addClass("hide")
                }
            }
            if( $searchResult.length ){
                if( $searchResult.hasClass("hide") ){
                    $searchResult.removeClass("hide");
                }
           }
            $drawer.addClass("open");
            $content.addClass("open");
            $button.addClass("open");
            $overlay.addClass("open");
            $body.addClass("open");
        }
    }
    
    function allList(allBtnName, listName){
        var $allBtn = $(allBtnName);
        if( !$allBtn.length ){
            return;
        }
        var $list = $(listName);
        
        $allBtn.on("click", function(e){
            e.preventDefault();
            if( !$list.length ){
                return;
            }
            if( $searchResult.length ){
                 if( !$searchResult.hasClass("hide") ){
                     $searchResult.addClass("hide");
                 }
            }
            if( $list.hasClass("hide")){
                if( $body.hasClass("open") ){
                    $drawer.removeClass("open");
                    $content.removeClass("open");
                    $button.removeClass("open");
                    $overlay.removeClass("open");
                    $body.removeClass("open");
                }
                $list.removeClass("hide");
            }
        });
        var $close = $list.find(".js_close");
        if( !$close.length ){
            return;
        }
        $close.on("click", function(e){
            e.preventDefault();
            if( !$list.hasClass("hide")){
                $list.addClass("hide")
                $("html,body").animate({scrollTop:0},'slow');
            }
            if( $searchResult.length ){
                if( $searchResult.hasClass("hide") ){
                    $searchResult.removeClass("hide");
                }
           }
        });
    }
    function moreList(moreBtnName, listName){
        var $moreBtn = $(moreBtnName);
        if( $moreBtn.length == 0 ){
            return;
        }
        $moreBtn.on("click", function(e){
            var i = 0;
            var $list = $(listName);
            async.eachSeries($list.children("li.hide"), function(element, next){
                if( i > 6){
                    next("break");
                    return;
                }
                $(element).removeClass("hide");
                i++;
                next();
            },function(err){
                var remainingValue = $list.children("li.hide").length;
                if(remainingValue == 0){
                    $moreBtn.addClass("hide");
                }else{
                	$moreBtn.children("span").html(remainingValue);
                }
            });
        });
    }
    
    function releaseFilter(filterName, $checkboxes){
        var $inputs = $("#updateForm [name=" + filterName + "]");
        async.eachSeries($inputs, function(element, next){
            $(element).remove();
            next();
        },function(err){
            async.eachSeries($checkboxes, function(element, next){
                var $checkbox = $(element);
                if( $checkbox.prop("checked")){
                    $checkbox.prop("checked", false);
                }
                next();
            },function(err){
                $inputOffset.val(1);
                $processing.addClass("open");
                $updateForm.submit();
                
            });
        });
    }
    function actionSelect(filterName, $checkboxes, value, $updateForm){
    	var $fliterFacet = $("#updateForm [name=ff]");
        if( $fliterFacet.length ){
            $fliterFacet.val(filterName);
        }else{
            $("<input>").attr({
                type: "hidden",
                name: "ff",
                value: filterName
            }).appendTo($updateForm);	
        }
        var $inputs = $("#updateForm [name=" + filterName + "]");
        async.eachSeries($inputs, function(element, next){
            $(element).remove();
            next();
        },function(err){
            var add = true;
            async.eachSeries($checkboxes, function(element, next){
                var $checkbox = $(element);
                if( $checkbox.prop("checked")){
                    $("<input>").attr({
                        type: "hidden",
                        name: filterName,
                        value: $checkbox.val()
                    }).appendTo($updateForm);
                    if( $checkbox.val() === value ){
                        add = false;
                    }
                }
                next();
            },function(err){
                if( add ){
                    $("<input>").attr({
                        type: "hidden",
                        name: filterName,
                        value: value
                    }).appendTo($updateForm);
                }
                $inputOffset.val(1);
                $processing.addClass("open");
                $updateForm.submit();
            });
        });
    }
    function actionFilter(filterName, $checkboxes, $updateForm){
        var $fliterFacet = $("#updateForm [name=ff]");
        if( $fliterFacet.length ){
            $fliterFacet.val(filterName);
        }else{
            $("<input>").attr({
                type: "hidden",
                name: "ff",
                value: filterName
            }).appendTo($updateForm);	
        }
        var $inputs = $("#updateForm [name=" + filterName + "]");
        async.eachSeries($inputs, function(element, next){
            $(element).remove();
            next();
        },function(err){
            async.eachSeries($checkboxes, function(element, next){
            	var $checkbox = $(element);
                if( $checkbox.prop("checked")){
                    $("<input>").attr({
                        type: "hidden",
                        name: filterName,
                        value: $checkbox.val()
                    }).appendTo($updateForm);
                }
                next();
            },function(err){
                $inputOffset.val(1);
                $processing.addClass("open");
                $updateForm.submit();
            });
        });
    }
    
     $(".js_toggle_sameName").on("click", function(e){
    	 var toggle = $(this).data('toggle');
    	 var key = $(this).data('key');

    	 if(toggle == true) {
    		 $("." + key).hide();
    		 $(this).data('toggle', false);
    	 } else {
    		 $("." + key).show();
    		 $(this).data('toggle', true);
    	 }
     });
    
    
});